import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { ConfirmDeleteDrawer } from '@dealstack/frontend/shared/components/ConfirmDeleteDrawer/ConfirmDeleteDrawer.tsx';

interface Props {
	opened: boolean;
	onClose: () => void;
	securityName?: string;
	isLoading: boolean;
	isSuccess?: boolean;
	onConfirm: () => void;
	alertTitle?: string;
	alertDescription?: string;
	disableDeleteButton?: boolean;
}

export const SecurityDeleteConfirmationDrawer = ({
	opened,
	onClose,
	securityName,
	isLoading,
	isSuccess,
	onConfirm,
	alertTitle,
	alertDescription,
	disableDeleteButton,
}: Props) => {
	const tCapManage = useTranslationCapManage();

	return (
		<ConfirmDeleteDrawer
			opened={opened}
			onClose={onClose}
			title={tCapManage('entity.delete.drawer.title')}
			alertTitle={alertTitle ?? tCapManage('delete.security.drawer.single.alertTitle')}
			alertDescription={
				alertDescription ?? tCapManage('delete.security.drawer.single.alertDescription')
			}
			inputLabel={tCapManage('delete.security.drawer.single.inputLabel')}
			inputPlaceholder={tCapManage('delete.security.drawer.single.inputPlaceholder')}
			hideAlertIcon={true}
			confirmDeleteText={securityName ?? 'delete'}
			wordMismatchErrorMessage={tCapManage('delete.security.drawer.single.wordMismatchError')}
			deleteBtnText={tCapManage('delete.security.drawer.confirmDelete')}
			cancelBtnText={tCapManage('delete.security.drawer.cancel')}
			deleteSuccess={isSuccess}
			deleteLoading={isLoading}
			handleDelete={onConfirm}
			disableDeleteButton={disableDeleteButton}
		/>
	);
};
